import React, { createContext, useContext, useState } from 'react'
// Toasts component removed - not needed for marketing site

export interface Toast {
    title?: string
    description: string | React.ReactNode
    error?: boolean
    createdAt?: number
    onUndo?: () => void
    onAction?: () => void
    actionLabel?: string
    actionClassName?: string
    verticalAlign?: string
    actionAsIcon?: React.ReactNode
    duration?: number
    image?: React.ReactNode
}

interface ToastContext {
    addToast: (toast: Toast) => number
    toasts: Toast[]
    removeToast: (createdAt: number) => void
}

export const Context = createContext<ToastContext | undefined>(undefined)
export const Provider = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const [toasts, setToasts] = useState<Toast[]>([])

    const addToast = (toast: Toast) => {
        const createdAt = toast.createdAt ?? Date.now()
        setToasts((prevToasts) => [...prevToasts, { ...toast, createdAt }])
        return createdAt
    }

    const removeToast = (createdAt: number) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.createdAt !== createdAt))
    }

    return <Context.Provider value={{ addToast, toasts, removeToast }}>{children}</Context.Provider>
}
export const useToast = (): {
    toasts: Toast[]
    addToast: (toast: Toast) => number
    removeToast: (createdAt: number) => void
} => {
    const toast = useContext(Context)
    return toast ?? { toasts: [], addToast: () => 0, removeToast: () => {} }
}
